module.exports = __webpack_public_path__ + "static/media/d1kz.5ae85cd9.pdf";